import React, { Component } from 'react'
import { connect } from 'react-redux'

// Styles
import './painttool.scss'

// Actions
import { getPaintToolInformation, savePaintToolInformation } from '../../../actions/settings'

// Utils
import { translation } from '../../../utils/helpers'

class PaintTool extends Component {

  constructor (props) {
    super(props)
    this.state = {
      PaintTool: 0,
      Active: false,
      BodyshopReference: ''
    }

    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.props.getPaintToolInformation(this.props.auth.user.ShopId)
      .then(({ data: { PaintTool, Active, BodyshopReference } }) => {
        this.setState({
          PaintTool,
          Active,
          BodyshopReference: BodyshopReference || ''
        })
      })
      .catch(err => {
        console.error('PaintTool settings', err)
      })
  }

  onChange (e) {
    let { name, value } = e.target
    let shouldBlur = false

    if (name === 'PaintTool') {
      value = parseInt(value)

      if (value === 0 && this.state.Active) {
        this.setState({
          Active: false
        })
      }
      shouldBlur = true
    } else if (name === 'Active') {
      if (this.state.PaintTool > 0) {
        value = value === 'true'
        shouldBlur = true
      } else {
        value = this.state.Active
        window.toastr.error(translation('14968'), translation('216'))
      }
    }

    this.setState({
      [name]: value
    }, () => {
      if (shouldBlur) {
        this.onBlur()
      }
    })
  }

  onBlur () {
    this.props.savePaintToolInformation(this.state)
      .then(() => {
        // window.toastr.success(translation('14967'), translation('13424'))
      })
      .catch(() => {
        window.toastr.error(translation('960'), translation('216'))
      })
  }

  render () {
    const { PaintTool, Active, BodyshopReference } = this.state
    return (
      <div className='painttool'>
        <div className='row'>
          <div className='col'>
            <div className='white__box'>
              <div className='title'>{translation('14965')}</div>
              <form className='fifty'>
                <div className='control__group radio__custom__outer painttool__system'>
                  <label>{translation('14966')}</label>
                  <div className='radio__custom__wrapper'>
                    <div className='radio__custom'>
                      <input
                        type='radio'
                        id='NoPaintTool'
                        name='PaintTool'
                        value={0}
                        onChange={this.onChange}
                        checked={PaintTool === 0} />
                      <label htmlFor='NoPaintTool'>{translation('433')}</label>
                    </div>
                    <div className='radio__custom'>
                      <input
                        type='radio'
                        id='ChromaWeb'
                        name='PaintTool'
                        value={1}
                        onChange={this.onChange}
                        checked={PaintTool === 1} />
                      <label htmlFor='ChromaWeb'>ChromaWeb</label>
                    </div>
                  </div>
                </div>
                <div className='control__group radio__custom__outer'>
                  <label>{translation('295')}</label>
                  <div className='radio__custom__wrapper'>
                    <div className='radio__custom'>
                      <input
                        type='radio'
                        id='Active_yes'
                        name='Active'
                        value='true'
                        onChange={this.onChange}
                        checked={Active} />
                      <label htmlFor='Active_yes'>{translation('47')}</label>
                    </div>
                    <div className='radio__custom'>
                      <input
                        type='radio'
                        id='Active_no'
                        name='Active'
                        value='false'
                        onChange={this.onChange}
                        checked={!Active} />
                      <label htmlFor='Active_no'>{translation('48')}</label>
                    </div>
                  </div>
                </div>
                <div className='control__group'>
                  <label>{translation('14969')}</label>
                  <input
                    type='text'
                    name='BodyshopReference'
                    value={BodyshopReference}
                    onChange={this.onChange}
                    onBlur={this.onBlur} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPaintToolInformation,
  savePaintToolInformation
})(PaintTool)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/PaintTool/index.js